import React from "react";
import { StoryblokBlockComponent } from "../../lib/storyblok/types/StoryblokComponent";
import ColumnGridUi from "../../ui/ColumnGrid";
import { ColumnGridBlock } from "../../lib/storyblok/types/blocks/ColumnGridBlock";
import { DynamicBlock } from "../DynamicBlock";
import { useLinks } from "../../lib/storyblok/useLinks";
import Button from "../../ui/Button";
import { useContentStyle, useButtonStyle } from "../../hooks/useStyle";

const ColumnGrid: StoryblokBlockComponent<ColumnGridBlock> = ({
  title,
  description,
  items,
  buttons,
  centered,
  twoColumns,
  spacing,
  outerSpacing,
  style,
  width,
}) => {
  const resolveLink = useLinks();
  const contentStyle = useContentStyle(style);
  const isInverted = style === "" || style === undefined ? false : contentStyle;
  const { buttonVariant } = useButtonStyle(style);

  const buttonCollection = buttons?.map((button) => (
    <Button
      key={button._uid}
      variant={button.buttonType || buttonVariant || "default"}
      href={button.buttonLink ? resolveLink(button.buttonLink) : ""}
    >
      {button.buttonText}
    </Button>
  ));

  return (
    <ColumnGridUi
      title={title}
      description={description}
      twoColumns={twoColumns}
      buttons={buttonCollection}
      centered={centered}
      spacing={spacing}
      outerSpacing={outerSpacing}
      style={style}
      width={width}
      inverted={isInverted}
    >
      {items.map((item) => (
        <DynamicBlock
          key={item._uid}
          content={{ ...item, style: style }}
          overrides={""}
        />
      ))}
    </ColumnGridUi>
  );
};

export default ColumnGrid;
